import { useGroup } from '../contexts/GroupContext';
import PortalPage from '../components/PortalPage';
import CallsPage from './usage/CallsPage';
import FleetScores from './FleetScores';

// The three Usage pages, each reading across every app — which one is the
// `section` prop, set by the route in App.js. The section nav picks between
// them, so the page adds no chooser of its own.
const PAGES = {
  usage: { title: 'Calls', lede: 'Every call your apps made in the last 30 days.' },
  scores: { title: 'OS-Evals', lede: 'Three scores for every app, and the checks behind them. Open one to see why.' },
  connections: { title: 'Connections', lede: 'How each app’s data links into the graph, and who builds on it.' },
};

export default function ApplicationsPage({ section = 'usage' }) {
  const { activeGroupId } = useGroup();
  const page = PAGES[section] || PAGES.usage;
  return (
    <PortalPage title={page.title} lede={page.lede}>
      {section === 'scores' && <FleetScores groupId={activeGroupId} />}
      {section === 'connections' && <FleetScores groupId={activeGroupId} mode="connections" />}
      {section !== 'scores' && section !== 'connections' && <CallsPage groupId={activeGroupId} />}
    </PortalPage>
  );
}
